<template>
  <div v-if="storeConfig('catalog/productalert/allow_stock')" @click="goToLogin" class="stock-alert">
    <svg width="36" height="25" viewBox="0 0 36 25" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="Icon Alert"><g id="bell"><circle id="pendulum" cx="18" cy="21.5" r="2" stroke="#E42313" stroke-width="2" /><rect id="edge" x="10" y="16.5" width="16" height="3" rx="1.5" stroke="#E42313" stroke-width="2" stroke-linejoin="round" /><path id="body" d="M11 9.5V16.5H25V9.5C25 5.63401 21.866 2.5 18 2.5C14.134 2.5 11 5.63401 11 9.5Z" stroke="#E42313" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" /><path id="hanger" d="M18 2V1" stroke="#E42313" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" /></g><g id="waves-s"><path id="wave-r-s" d="M29.5 15.5V15.5C31.1569 13.8431 31.1569 11.1569 29.5 9.5V9.5" stroke="#E42313" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" /><path id="wave-l-s" d="M6.5 9.5V9.5C4.84315 11.1569 4.84315 13.8431 6.5 15.5V15.5" stroke="#E42313" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" /></g><g id="waves-l"><path id="wave-r-l" d="M32 18.5V18.5C35.3137 15.1863 35.3137 9.81371 32 6.5V6.5" stroke="#E42313" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" /><path id="wave-l-l" d="M4 6.5V6.5C0.686293 9.81371 0.686293 15.1863 4 18.5V18.5" stroke="#E42313" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" /></g></g></svg>
    Benachrichtigen Sie mich, wenn das Produkt auf Lager ist
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { ModalList } from 'theme/store/ui/modals'
import i18n from '@vue-storefront/i18n'

export default {
  name: 'MProductStockAlert',
  computed: {
    ...mapGetters({
      storeConfig: 'storeConfig/getConfigValue',
      isLoggedIn: 'user/isLoggedIn'
    })
  },
  props: {
    product: {
      type: Object,
      default: null
    }
  },
  methods: {
    ...mapActions({
      openModal: 'ui/openModal',
      queueStockAlert: 'productAlerts/queueStockAlert',
      sendStockAlert: 'productAlerts/sendStockAlert'
    }),
    goToLogin () {
      this.queueStockAlert({ product: this.product })
      if (this.isLoggedIn) {
        this.handleStockAlert();
      } else {
        this.openModal({ name: ModalList.Auth, payload: 'login' })
        this.$bus.$on('notification-progress-stop', () => {
          if (this.isLoggedIn) {
            this.handleStockAlert();
          }
        })
      }
    },
    async handleStockAlert () {
      const result = await this.sendStockAlert()
      this.$store.dispatch('notification/spawnNotification', {
        type: 'success',
        message: i18n.t('Alert subscription has been saved.'),
        action1: { label: i18n.t('OK') }
      })
    }
  }
}
</script>
